import React from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { Sparkles } from 'lucide-react';

const motionProps = (reduceMotion) =>
  reduceMotion
    ? {}
    : {
        whileHover: { scale: 1.04 },
        whileTap: { scale: 0.96 },
      };

/**
 * Small chip that pre-fills an AIChat question and opens the panel.
 */
export default function AskVantiChip({ question, label, size = 'sm' }: any) {
  const reduceMotion = useReducedMotion();

  const handleClick = () => {
    window.dispatchEvent(new CustomEvent('vanti:ask', { detail: { question } }));
  };

  return (
    <motion.button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 rounded-full border border-vivid-green-cyan/30 bg-vivid-green-cyan/10 font-medium text-vivid-green-cyan transition-colors hover:bg-vivid-green-cyan/20 ${
        size === 'xs' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
      }`}
      {...motionProps(reduceMotion)}
    >
      <Sparkles className={size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3'} aria-hidden />
      {label ?? 'Ask Vanti'}
    </motion.button>
  );
}
